import { render, staticRenderFns } from "./Moderation.view.vue?vue&type=template&id=33df7bda"
import script from "./Moderation.view.vue?vue&type=script&lang=ts"
export * from "./Moderation.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports